define("settings/controllers/groups/trade", ["exports", "@ember/controller", "@ember/utils", "@ember/array", "@ember/object", "@ember/service", "ember-concurrency-decorators", "@glimmer/tracking"], function (_exports, _controller, _utils, _array, _object, _service, _emberConcurrencyDecorators, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let TradeController = (_class = class TradeController extends _controller.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "auth", _descriptor2, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor3, this);

      _initializerDefineProperty(this, "segment", _descriptor4, this);

      _initializerDefineProperty(this, "intl", _descriptor5, this);

      _initializerDefineProperty(this, "router", _descriptor6, this);

      _initializerDefineProperty(this, "store", _descriptor7, this);

      _initializerDefineProperty(this, "movedSocialProfiles", _descriptor8, this);

      _initializerDefineProperty(this, "movedSocialIdentities", _descriptor9, this);

      _initializerDefineProperty(this, "profilesMovedBetweenGroups", _descriptor10, this);
    }

    get lastGroup() {
      return this.auth.lastGroup;
    }

    get movedSocialProfilesWithLinkinbio() {
      return this.movedSocialProfiles.filter(socialProfile => {
        return socialProfile.isInstagram && socialProfile.get('socialIdentity.linkinbioPage.enabled');
      });
    }

    get movedSocialProfilesCount() {
      return this.movedSocialProfiles.length;
    }

    get movedSocialIdentitiesCount() {
      return this.movedSocialIdentities.length;
    }

    get movedSocialProfileTypes() {
      return this.movedSocialProfiles.map(profile => profile.profileType);
    }

    get movedSocialProfileNicknames() {
      return this.movedSocialProfiles.map(profile => profile.nickname);
    }

    get movedSocialProfileIds() {
      return this.movedSocialProfiles.map(profile => profile.id);
    }

    get profilesMovedBetweenGroupsCount() {
      return this.profilesMovedBetweenGroups.length;
    }

    get didMoveProfilesBetweenGroups() {
      return this.profilesMovedBetweenGroupsCount > 0;
    }

    trackProfileTrade(_ref) {
      let {
        profile
      } = _ref;

      if (profile) {
        this.movedSocialProfiles.addObject(profile);
      }
    }

    trackGroupTrade(_ref2) {
      let {
        identity
      } = _ref2;
      this.movedSocialIdentities.addObject(identity);
      identity.socialProfiles.forEach(profile => {
        this.movedSocialProfiles.addObject(profile);
        this.profilesMovedBetweenGroups.addObject(profile);
      });
    }

    trackProfileMovedAcrossGroups(_ref3) {
      let {
        profile
      } = _ref3;
      this.profilesMovedBetweenGroups.addObject(profile);
    }

    *saveChanges() {
      if (this.didMoveProfilesBetweenGroups || this.movedSocialProfilesWithLinkinbio.length > 0) {
        yield this.confirmChanges.perform();
      } //created group is necessary for collectionAction - Ian K


      const tempGroup = this.store.createRecord('group');
      const groups = {
        groups: this._getFormattedGroups()
      };
      const response = yield tempGroup.rearrange(groups);
      this.store.pushPayload(response);

      this._disableLinkinbioForSocialProfilesMovedBetweenGroups();

      this.trackChangesInSegment();
      this.alerts.success(this.intl.t('alerts.account.groups.group.social_profiles.move.update_success'));
      this.router.transitionTo('account.groups');
    }

    *confirmChanges() {
      yield this.dialogManager.confirm(this.intl.t('account.groups.group.social_profiles.move.confirm_title', {
        count: this.movedSocialProfilesCount
      }), {
        description: this._getConfirmationDescription(this.movedSocialProfilesWithLinkinbio),
        confirmButton: this.intl.t('account.groups.group.social_profiles.move.confirm_button')
      });
    }

    trackChangesInSegment() {
      this.segment.track('moved-social-profile', {
        moved_social_set: this.movedSocialIdentitiesCount,
        moved_social_profile: this.movedSocialProfilesCount,
        profile_types: this.movedSocialProfileTypes,
        profile_nicknames: this.movedSocialProfileNicknames,
        profile_ids: this.movedSocialProfileIds
      }, {
        user: 'currentUserModel.id'
      });
    }

    _disableLinkinbioForSocialProfilesMovedBetweenGroups() {
      this.profilesMovedBetweenGroups.forEach(profile => {
        profile.setProperties({
          linkinbioEnabled: false
        });
      });
    }

    _getFormattedGroups() {
      return this.groups.map(group => {
        return {
          id: group.id,
          social_identities: this._getFormattedIdentities(group)
        };
      });
    }

    _getFormattedIdentities(group) {
      return (0, _utils.isEmpty)(group.temporaryIdentities) && group.traded !== true ? group.socialIdentities.filter(identity => identity.id).map(identity => {
        return {
          id: identity.id,
          social_profiles: this._getFormattedSocialProfiles(identity)
        };
      }) : group.temporaryIdentities.filter(tempIdentity => tempIdentity.identity).map(tempIdentity => {
        return {
          id: tempIdentity.identity.id,
          social_profiles: this._getFormattedSocialProfiles(tempIdentity.identity)
        };
      });
    }

    _getFormattedSocialProfiles(identity) {
      return (0, _utils.isEmpty)(identity.temporaryProfiles) ? identity.socialProfiles.filter(profile => profile).map(profile => {
        return {
          id: profile.id
        };
      }) : identity.temporaryProfiles.filter(tempProfile => tempProfile.profile).map(tempProfile => {
        return {
          id: tempProfile.profile.id
        };
      });
    }

    _getConfirmationDescription(profilesWithLinkinbio) {
      if ((0, _utils.isEmpty)(profilesWithLinkinbio)) {
        return this.intl.t('account.groups.group.social_profiles.move.confirm');
      } else {
        return this.intl.t('account.groups.group.social_profiles.move.confirm_linkinbio_enabled', {
          names: profilesWithLinkinbio.map(profile => profile.displayName).join(" ".concat(this.intl.t('shared_words.and'), " ")),
          count: profilesWithLinkinbio.length
        });
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "movedSocialProfiles", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)();
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "movedSocialIdentities", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)();
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "profilesMovedBetweenGroups", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return (0, _array.A)();
    }
  }), _applyDecoratedDescriptor(_class.prototype, "trackProfileTrade", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackProfileTrade"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackGroupTrade", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackGroupTrade"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackProfileMovedAcrossGroups", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackProfileMovedAcrossGroups"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveChanges", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "saveChanges"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirmChanges", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "confirmChanges"), _class.prototype)), _class);
  _exports.default = TradeController;
});